import { motion } from "framer-motion";
import { FadeIn } from "@/components/FadeIn";
import { ServiceIcon } from "@/components/ServiceIcon";
import { useLang } from "@/context/LanguageContext";

export const Services = ({ content }) => {
  const { t, tc } = useLang();
  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  return (
    <section id="leistungen" data-testid="services-section" className="py-24 md:py-32 bg-white">
      <div className="container-x">
        <FadeIn className="max-w-2xl mb-16">
          <span className="overline">{t("services.overline")}</span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-slate-900 mt-3 mb-4">{t("services.title")}</h2>
          <p className="text-slate-500 md:text-lg">{t("services.subtitle")}</p>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {(content.services || []).map((s, i) => (
            <motion.div
              key={i}
              data-testid={`service-card-${i}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.5, delay: (i % 3) * 0.08, ease: [0.22, 1, 0.36, 1] }}
              className="card-light p-7 group cursor-default"
            >
              <div className="w-14 h-14 rounded-2xl bg-blue-50 border border-blue-100 flex items-center justify-center mb-5 group-hover:bg-blue-600 group-hover:border-blue-600 transition-all duration-300">
                <ServiceIcon name={s.icon} className="w-7 h-7 text-blue-600 group-hover:text-white transition-colors duration-300" />
              </div>
              <h3 className="text-xl font-semibold text-slate-900 mb-2">{tc(s.title)}</h3>
              <p className="text-slate-500 text-sm leading-relaxed">{tc(s.desc)}</p>
            </motion.div>
          ))}
        </div>

        <FadeIn className="mt-14 text-center">
          <button data-testid="services-cta" onClick={() => scrollTo("termin")} className="btn-blue">
            {t("services.cta")}
          </button>
        </FadeIn>
      </div>
    </section>
  );
};
